/* TuMundoPet · calculadora de dosificación.
   Port de calcDosis() de la maqueta. Los datos vienen de tmp-calculadora.json, que arma
   tools/calculadora.py. */
(function () {
  'use strict';

  var seccion = document.getElementById('calculadora');
  if (!seccion) return;

  var elLitros = document.getElementById('calc-litros');
  var elFam = document.getElementById('calc-fam');
  var elOut = document.getElementById('calc-out');
  var elCob = document.getElementById('calc-cob');
  var boton = document.getElementById('calc-ir');
  var datos = [];

  function clp(n) {
    return '$' + Math.round(n).toLocaleString('es-CL');
  }
  function num(n) {
    return Number(n).toLocaleString('es-CL');
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* En una familia de formatos lo que distingue una fila de otra es el envase: truncar el
     nombre a secas deja cuatro filas idénticas, así que primero se saca la medida. */
  function nombreCorto(t) {
    var n = t.replace(/\s*-\s*/g, ' · ').replace(/\s+/g, ' ').trim();
    n = n.replace(/\s*·?\s*\d+([.,]\d+)?\s*(ml|cc|lt|lts|l|grs|gr|g|kgs|kg|oz)\b/gi, '');
    return n;
  }

  function llenarFamilias() {
    var cuenta = {};
    datos.forEach(function (p) {
      if (p.f) cuenta[p.f] = (cuenta[p.f] || 0) + 1;
    });
    Object.keys(cuenta)
      .sort(function (a, b) { return cuenta[b] - cuenta[a] || a.localeCompare(b, 'es'); })
      .forEach(function (k) {
        var o = document.createElement('option');
        o.value = k;
        o.textContent = k + ' (' + cuenta[k] + ')';
        elFam.appendChild(o);
      });
  }

  /* Ordenar sólo por costo por litro tratado premia siempre el formato más grande: para un
     acuario de 120 L terminaba recomendando un bidón que trata 141.500 litros. El costo por
     litro sigue siendo la comparación justa, pero antes hay que descartar los envases
     desproporcionados para el acuario de la persona. */
  var MAX_DOSIS = parseInt(seccion.dataset.maxDosis, 10) || 60;
  var MAX_ENVASES = parseInt(seccion.dataset.maxEnvases, 10) || 30;

  function evaluar(p, litros) {
    var envases = Math.ceil(litros / p.r);
    return {
      p: p,
      envases: envases,
      total: p.p * envases,
      por1000: (p.p / p.r) * 1000,
      dosis: p.r / litros,          // cuántas veces alcanza para tratar el acuario entero
    };
  }

  function calcular() {
    var litros = Math.max(1, parseInt(elLitros.value || '0', 10) || 0);
    var fam = elFam.value;

    var todos = datos
      .filter(function (p) { return !fam || p.f === fam; })
      .map(function (p) { return evaluar(p, litros); })
      .filter(function (x) { return x.envases <= MAX_ENVASES; })
      .sort(function (a, b) { return a.por1000 - b.por1000; });

    var aMedida = todos.filter(function (x) { return x.dosis <= MAX_DOSIS; });
    var sobredimensionado = aMedida.length === 0 && todos.length > 0;
    var cands = (sobredimensionado ? todos : aMedida).slice(0, 5);

    if (!cands.length) {
      elOut.innerHTML =
        '<p class="calc-vacio">Todavía no tenemos el rendimiento cargado para esa combinación. ' +
        '<a href="/pages/contact">Escríbenos</a> y te decimos la dosis exacta.</p>';
      return;
    }

    elOut.innerHTML =
      '<div class="calc-scroll"><table class="tabla calc-tabla">' +
      '<thead><tr><th>Producto</th><th>Rinde</th><th>Dosis</th><th>Para ' + num(litros) + ' L</th>' +
      '<th>Costo</th><th>Por 1.000 L</th><th>Te alcanza</th></tr></thead><tbody>' +
      cands.map(function (x, i) {
        return '<tr' + (i === 0 ? ' class="mejor"' : '') + '>' +
          '<td><a href="/products/' + encodeURIComponent(x.p.h) + '" class="calc-prod">' +
          (x.p.img ? '<img src="' + esc(x.p.img) + '" alt="" loading="lazy" class="calc-img">' : '') +
          '<span class="calc-prod-txt">' + esc(nombreCorto(x.p.t)) +
          (x.p.fmt ? '<span class="fmt">' + esc(x.p.fmt) + '</span>' : '') +
          (i === 0 ? '<span class="etq">mejor costo por litro</span>' : '') + '</span></a></td>' +
          '<td class="mono">' + num(x.p.r) + ' L</td>' +
          '<td class="mono">' + (x.p.d ? esc(x.p.d) : '—') + '</td>' +
          '<td class="mono">' + x.envases + ' envase' + (x.envases > 1 ? 's' : '') + '</td>' +
          '<td class="mono">' + clp(x.total) + '</td>' +
          '<td class="mono">' + clp(x.por1000) + '</td>' +
          '<td class="mono">' + (x.dosis >= 1 ? num(Math.round(x.dosis)) + ' dosis' : 'parcial') + '</td></tr>';
      }).join('') +
      '</tbody></table></div>' +
      (sobredimensionado
        ? '<p class="calc-ojo">Para ese litraje sólo tenemos formatos grandes: el más chico te ' +
          'alcanzaría para muchísimas dosis. Conviene consultar antes de comprar.</p>'
        : '');
  }

  try {
    var elDatos = document.getElementById('calc-datos');
    var raw = JSON.parse(elDatos.textContent);
    datos = raw.filter(function (p) {
      return typeof p.r === 'number' && p.r > 0 && typeof p.p === 'number' && p.p > 0;
    });

    /* data-total viene de paginate.items (ver tmp-calculadora.liquid): el total de productos
       de la colección, antes del filtro por rendimiento que Liquid ya hace a propósito. Un
       hueco chico es normal (productos sin rendimiento_litros cargado); uno grande, o que el
       total pase de 250, avisa de que el paginate se quedó corto y hay productos sin listar. */
    var total = parseInt(elDatos.dataset.total, 10);
    if (total && raw.length < total) {
      console.warn(
        '[calculadora] la colección "calculadora" tiene ' + total + ' productos pero el JSON ' +
        'trae ' + raw.length + '. Una diferencia chica es normal (productos sin rendimiento ' +
        'cargado); si es grande, o el catálogo ya supera 250, revisa el paginate en ' +
        'tmp-calculadora.liquid.'
      );
    }

    if (elCob) elCob.textContent = num(datos.length);
    llenarFamilias();
    calcular();
  } catch (e) {
    elOut.innerHTML = '<p class="calc-vacio">No pudimos cargar los datos de rendimiento. Recarga la página.</p>';
  }

  boton.addEventListener('click', calcular);
  elFam.addEventListener('change', calcular);
  elLitros.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); calcular(); }
  });
})();
